export const cleanupOperationLabel: Record<
  API.Staff.StaffOrderCleanupOperation,
  string
> = {
  REFUND_UNUSED_ORDER: "未使用订单退款",
  DELETE_UNUSED_WALLET_ORDER: "删除未使用积点订单",
  DELETE_UNUSED_LEVEL_ORDER: "删除未使用会员订单",
}

export const cleanupOperationColor: Record<
  API.Staff.StaffOrderCleanupOperation,
  string
> = {
  REFUND_UNUSED_ORDER: "blue",
  DELETE_UNUSED_WALLET_ORDER: "volcano",
  DELETE_UNUSED_LEVEL_ORDER: "red",
}

export const cleanupStatusLabel: Record<
  API.Staff.StaffOrderCleanupStatus,
  string
> = {
  PROCESSING: "处理中",
  SUCCESS: "成功",
  CONFIRMED: "已确认退款到账",
  FAILED: "失败",
}

export const cleanupStatusColor: Record<
  API.Staff.StaffOrderCleanupStatus,
  string
> = {
  PROCESSING: "gold",
  SUCCESS: "blue",
  CONFIRMED: "green",
  FAILED: "red",
}
